import classNames from "classnames";
import noop from "lodash/noop";
import React, { FunctionComponent, ReactNode } from "react";
import "./style.scss";

interface Props {
  children: ReactNode;
  disabled?: boolean;
  onClick?: (event: MouseEvent) => void;
  size: "xs" | "s" | "m";
  title?: string;
  type: "primary" | "secondary" | "tertiary";
}

const ButtonSmily: FunctionComponent<Props> = ({
  children,
  disabled = false,
  onClick = noop,
  size,
  title,
  type,
}) => {
  const className = classNames(`ButtonSmily ButtonSmily--size-${size} ButtonSmily--type-${type}`, {
    "ButtonSmily--disabled": disabled,
  });

  return (
    <button className={className} disabled={disabled} onClick={onClick} title={title}>
      {children}
    </button>
  );
};

export default ButtonSmily;
